import { render, staticRenderFns } from "./time-slot-selector.vue?vue&type=template&id=588a2f1e"
import script from "./time-slot-selector.vue?vue&type=script&lang=js"
export * from "./time-slot-selector.vue?vue&type=script&lang=js"
import style0 from "./time-slot-selector.vue?vue&type=style&index=0&id=588a2f1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports